import { format, isSameMonth, isSameYear } from 'date-fns';

export const formatCompactDateRange = (start: Date, end: Date) => {
  // 1. Format the end date completely. This part is always the same.
  // Format: 02.07.2025
  const endFormatted = format(end, 'dd.MM.yyyy');

  // 2. Check if the dates are in the same year.
  if (!isSameYear(start, end)) {
    // Different year: Format both dates fully.
    // e.g., 01.01.2024-02.06.2025
    return `${format(start, 'dd.MM.yyyy')} - ${endFormatted}`;
  }

  // 3. At this point, we know they are in the same year.
  // Now, check if they are also in the same month.
  if (!isSameMonth(start, end)) {
    // Different month, but same year.
    // Format: 1.01-02.07.2025
    const startFormatted = format(start, 'd.MM'); // Use 'd' for day without leading zero
    return `${startFormatted} - ${endFormatted}`;
  }

  // 4. At this point, we know they are in the same month and same year.
  // Format: 1-02.06.2025
  const startFormatted = format(start, 'd'); // Use 'd' for day without leading zero
  return `${startFormatted} - ${endFormatted}`;
};
